import { Box, Checkbox, Typography } from "@material-ui/core";
import * as React from "react";
import { IActionPlanItem } from "src/common/types";
import { Comment } from "src/common/components";
interface IProps {
  item: IActionPlanItem;
  disabled?: boolean;
}

const ActionItems = ({ item, disabled = false }: IProps) => {
  return (
    <>
      <Box display="flex" alignItems="flex-start">
        <Checkbox
          checked={item.completed}
          disabled
          style={{
            paddingTop: 0,
            paddingLeft: 0
          }}
        />
        <Typography>{item.itemText} </Typography>
      </Box>
      {item.comment && <Comment readOnly={disabled} onChange={() => ({})} defaultValue={item.comment} />}
    </>
  );
};

export default ActionItems;
